export default __webpack_public_path__ + "static/media/form.60fe3d6b.png";